import { NgModule } from '@angular/core'

import { AngularFireModule } from 'angularfire2'
import { AngularFirestore } from 'angularfire2/firestore'
import { AngularFireAuthModule, AngularFireAuth } from 'angularfire2/auth'
import { AngularFireStorageModule } from 'angularfire2/storage'

import { FirebaseConfig } from '../../../config/config'

import { ApiService } from './api.service'
import { FirestoreService } from './firestore.service'
import { FIREBASE_SETTINGS } from './firebase.settings.token'

@NgModule({
  imports: [
    AngularFireModule.initializeApp(FirebaseConfig),
    AngularFireAuthModule,
    AngularFireStorageModule
  ],
  providers: [
    AngularFireAuth,
    AngularFirestore,

    FirestoreService,
    ApiService,

    { provide: FIREBASE_SETTINGS, useValue: FirebaseConfig },
  ]
})
export class DataModule {
  constructor () { }
}
